<template>
  <v-list-item-group v-bind="$attrs">
    <slot></slot>
  </v-list-item-group>
</template>


<script>
export default {
name: "AppListItemGroup"
}
</script>

<style>
.v-list-item .v-list-item__title, .v-list-item .v-list-item__subtitle{
  line-height: 1.3;
}
</style>